import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { OrderDetailsPageContext } from "@insite/content-library/Pages/OrderDetailsPage";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, useContext } from "react";
import { css } from "styled-components";

export interface OrderCustomerPoStyles {
    wrapper?: InjectableCss;
    titleText?: TypographyProps;
    ordeOrderCustomerPo?: TypographyProps;
}

export const orderCustomerPoStyles: OrderCustomerPoStyles = {
    wrapper: {
        css: css`
            padding-bottom: .625rem;
        `,
    },
    titleText: {
        variant: "h6",
        as: "h2",
        css: css`
            @media print {
                font-size: .75rem;
            }
            margin-bottom: .31250625rem;
        `,
    },
};

const styles = orderCustomerPoStyles;

const OrderPONumber: FC = () => {
    const { value: order } = useContext(OrderStateContext);
    if (!order || !order.customerPO) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.titleText} id="orderPONumber">
                {translate("PO Number")}
            </Typography>

            <Typography {...styles.ordeOrderCustomerPo} aria-labelledby="orderPONumber">
                {order.customerPO}
            </Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: OrderPONumber,
    definition: {
        allowedContexts: [OrderDetailsPageContext],
        group: "Order Details",
    },
};

export default widgetModule;
